<template>
  <v-container grid-list-md fluid>
    <!-- <v-layout style="margin-left: 95%;">
        <v-flex>
          <refresh-button @refresh="getData()"></refresh-button>
        </v-flex>
    </v-layout>-->

    <!-- <v-flex md12> -->
    <!-- </v-flex> -->
    <!-- </v-layout> -->
  </v-container>
</template>

<script>
import Services from "@/services/SubCompanyServices";

export default {
  data() {
    return {
      items: {},
      headers: [
        {
          text: "Time",
          align: "center",
          sortable: false,
        },
        {
          text: "Vehicle Layout",
          align: "left",
          sortable: false,
        },
        {
          text: "Route",
          align: "left",
          sortable: false,
        },
        {
          text: "Available Seats",
          align: "right",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ],
      queryParams: {
        search: null,
        company_id: null,
        sub_company_id: null,
        limit: 10,
        offset: 0,
      },
      openPanel: [true],
      dialogType: "",
      dialogStatus: false,
      dialogLoading: false,
      viewData: {},
      seats: [],
      vehicleLayout: [],
    };
  },
  created: function() {
    // this.getData();
  },
  methods: {
    async getData() {
      // Start Loading
      this.$clearInfoBar();
      this.items = [];
      this.$store.dispatch("startLoading");

      this.queryParams.company_id = this.$store.state.company.id;
      this.queryParams.sub_company_id = this.$store.state.subcompany.id;

      try {
        let response = await Services.getDashboard(this.queryParams);

        this.items = await response.data;
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    async openViewDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;
      this.viewData = data;

      const details = await data.vehicle_layout;

      var layout = [];
      const seats = await data.seats;
      this.seats = (await seats.length) === 0 ? details.seats : seats;

      for (var f = 1; f <= details.floor_count; f++) {
        let data = {
          floor_no: f,
          column: [],
        };
        for (var c = 1; c <= details.column_count; c++) {
          let col = { data: [] };
          for (var s = 0; s < details.seats.length; s++) {
            if (details.seats[s].floor_no === f) {
              if (details.seats[s].column_no === c) {
                var detail = {
                  seat_name: details.seats[s].seat_name,
                  status: details.seats[s].status,
                };
                for (var v = 0; v < seats.length; v++) {
                  if (details.seats[s].floor_no === seats[v].floor_no) {
                    if (details.seats[s].column_no === seats[v].column_no) {
                      if (details.seats[s].row_no === seats[v].row_no) {
                        detail.status = seats[v].status;
                      }
                    }
                  }
                }
                if (details.seats[s].status === 0) {
                  this.viewData.seat_count++;
                }

                col.data.push(await detail);
              }
            }
          }
          data.column.push(col);
        }
        layout.push(data);
      }
      console.log(layout);
      this.vehicleLayout = await layout;

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    saveDialog() {
      // Condition Form Required Form Validation
    },
    async closeDialog() {
      this.viewData = {};
      this.dialogType = "";
      this.dialogStatus = false;
    },
  },
};
</script>

<style></style>
